// @flow

export const config = (
    state: {} = {},
    action: { type: string, config: {} }
): {} => {
    switch (action.type) {
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/reducer/analytics/reducers/config.js